<template>
	<v-card>
		<v-card-title>
			<span class="headline">مشخصات ضامن</span>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
				<v-container>
					<v-row>
						<v-col cols="12" md="12" class="py-0">
							<v-text-field ref="firstName" v-model="localData.firstName" label="نام*"
								:error-messages="errorMessages"
								:rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="12" class="py-0">
							<v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*"
								:error-messages="errorMessages"
								:rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="12" class="py-0">
							<v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر*"
								:error-messages="errorMessages"
								:rules="[() => !!localData.fatherName || 'نام پدر را وارد کنید']" required />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12" class="py-0">
							<v-text-field ref="nationalCode" v-model="localData.nationalCode" maxlength="10"
								label="کد ملی*" :error-messages="errorMessages"
								:rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="12" class="py-0">
							<v-card color="#eee" class="px-2 d-flex" elevation="0">
								<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" />
								<div v-if="!localData.mobileVerified || initMobile !== localData.mobile"
									class="d-flex px-2 align-center" style="width:170px">
									<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید"
										:rules="[() => !!localData.mobileOtp || 'الزامی']" required />
									<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP"
										:loading="otpLoading"><small>ارسال کد</small></v-btn>
									<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="12" class="py-0">
							<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="تلفن ثابت" />
						</v-col>

					</v-row>
					<v-row>
						<v-col cols="12" md="12" class="pt-2">
							<div>
								<div>تاریخ تولد</div>
								<date-picker ref="birthdate" autoSubmit v-model="localData.birthDate"
									format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY"
									:error-messages="errorMessages" clearable />
								<div class="red--text">
									{{ birthDatePickerValidatioin }}
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-form>
		</v-card-text>

		<v-divider></v-divider>

		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="loading" @click="submit">
				ذخیره
			</v-btn>
		</v-card-actions>

		<confirm-dlg ref="confirm" />

	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyThirdPersonAssurance',
		components: {
			Countdown: () => import('@/components/Countdown'),
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			area: { type: String },
		},
		data() {
			return {
				errorMessages: '',
				localData: { id: 0 },
				birthDatePickerValidatioin: '',
				loading: false,
				otpLoading: false,
				sendCodeVisible: true,
				initMobile: ''
			}
		},
		mounted() {
		},
		computed: {
		},
		methods: {
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.localData.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.otpLoading = true
				api.post('account/SendOTP/' + this.localData.mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.otpLoading = false
					})
			},
			async submit() {
				this.birthDatePickerValidatioin = ''
				if (!this.localData.birthDate) {
					this.birthDatePickerValidatioin = 'تاریخ تولد را وارد کنید'
					return
				}
				if (!this.$refs.form.validate() || this.birthDatePickerValidatioin) {
					toast.error('ابتدا تمام بخش های فرم را تکمیل نمایید.')
					return
				}
				let data = { sendSms: true }
				data = Object.assign(data, this.localData)
				this.loading = true
				api.post(`${this.area}/member/` + (this.localData.id === 0 ? 'CreateAsThirdPerson' : 'edit'), data)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', response)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			}
		},
	}
</script>
<style></style>
